import messages from '../../../locale/messages';
import { inputTextLimit, inputDescLimit } from '../../../helpers/inputTextLimit';

const validate = values => {

    const errors = {}

    if (!values.locationName) {
        errors.locationName = messages.required;
    } else if (values.locationName.trim() == "") {
        errors.locationName = messages.required;
    } else if (values?.locationName?.length > inputTextLimit) {
        errors.locationName = messages.textAreaError;
    }

    if (!values.description) {
        errors.description = messages.required;
    } else if (values.description.trim() == "") {
        errors.description = messages.required;
    } else if (values.description.length > inputDescLimit) {
        errors.description = messages.descLimitError;
    }

    return errors
}

export default validate;